import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import './ProductsLayout.css';

interface ProductsLayoutProps {
  children?: ReactNode;
}

export default function ProductsLayout({ children }: ProductsLayoutProps = {}) {
  return (
    <div className="products-layout">
      <div className="products-container">
        {children || <Outlet />}
      </div>
    </div>
  );
}
